import { EmptyState, PageHeader } from '@saniplus/ui';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

/**
 * A route the navigation offers and no feature has landed yet.
 *
 * It exists so the shell is complete from the first commit: every nav item
 * leads somewhere, `aria-current` still resolves, and a supervisor clicking
 * *Ajustements* before Track C ships reads a sentence rather than the 404 page,
 * which would say the link is wrong when the link is right.
 *
 * `app/router.tsx` mounts it only for the paths no `features/<name>/routes.tsx`
 * has claimed, so it disappears on its own as the features arrive.
 */
export function PendingRoute() {
  const { t } = useTranslation('nav');
  const { pathname } = useLocation();

  return (
    <div className="flex min-w-0 flex-col gap-5">
      <PageHeader title={pathname} />
      <EmptyState
        headingLevel={2}
        title={t('pending.title')}
        description={t('pending.body')}
      />
    </div>
  );
}
